<template>
  <div class="tb-form-group">
    <label class="tb-label">CTA</label>

    <div class="tb-checkbox">
      <input type="checkbox" id="showCtaText" v-on:change="setField('showCtaText', $event.target.checked)" :checked="getField('showCtaText')" data-test="displays-editors-showCTA">
      <label class="checkbox" for="showCtaText">Show</label>
    </div>

    <template v-if="getField('showCtaText')">
      <input class="tb-input" type="text" v-on:keyup.right.stop v-on:keyup.left.stop v-on:change="setField('ctaText', $event.target.value)" :value="getField('ctaText')" data-test="displays-editors-ctaText">
    </template>
  </div>
</template>

<script>
import editingMixins from '../../../mixins/editing-mixins';

export default {
  mixins: [editingMixins],
};
</script>
